/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 7th 2022, 7:27:41 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSActionButton, EmptyStateActionWrapper, EmphasisText, Image } from "ui-widgets";
import Typography from "@mui/material/Typography";
import { useOSFormContext } from "ui-widgets/forms/providers";
import { TaskTemplate } from "lib/schemas";

interface EmptyNotificationsCTAProps {
  handleAddNewNotification: () => void;
}

export const EmptyNotificationsCTA = ({ handleAddNewNotification }: EmptyNotificationsCTAProps) => {
  const { watch } = useOSFormContext<TaskTemplate>();
  const watchedTaskTitle = watch<keyof TaskTemplate>("title");
  return (
    <EmptyStateActionWrapper
      title={
        <>
          No notifications for <EmphasisText>{watchedTaskTitle}</EmphasisText>
        </>
      }
      description={
        <Typography>
          Configure Email and/or SMS notifications to be sent to either the submitter or team members for different
          state values of the workflow task status.
        </Typography>
      }
      illustrationGraphic={<Image src="/img/smartphone.png" />}
    >
      <OSActionButton variant="contained" size="large" onClick={handleAddNewNotification}>
        Add Notification
      </OSActionButton>
    </EmptyStateActionWrapper>
  );
};
